export default "__VITE_ASSET__4$V5EIWl__"